interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  as?: "h2" | "h3";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  as = "h2",
}: SectionHeadingProps) {
  const Heading = as;
  const isCenter = align === "center";

  return (
    <div className={`flex flex-col gap-3 ${isCenter ? "items-center text-center" : "items-start"}`}>
      {eyebrow ? (
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 font-label text-xs font-medium tracking-wide text-accent-900">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
          {eyebrow}
        </span>
      ) : null}
      <Heading className="font-heading text-2xl md:text-4xl leading-snug text-foreground-950">
        {title}
      </Heading>
      {desc ? (
        <p className={`max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600 ${isCenter ? "mx-auto" : ""}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}